import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { AUTH_LOCAL_STORAGE_KEY } from '../core/AuthHelpers'

const AutoLogin = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const token = searchParams.get('token')

    if (token) {
      // Clear ALL auth-related storage to ensure clean login
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
      localStorage.removeItem('bot_id')
      sessionStorage.clear()

      // Small delay to ensure storage is cleared
      setTimeout(() => {
        // Store auth in localStorage with same format as regular login
        const authData = {
          api_token: token
        }
        localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, JSON.stringify(authData))

        // Force full page reload to reset all React state
        window.location.replace('/campaigns')
      }, 100)
    } else {
      // No token provided, redirect to login
      navigate('/auth/login')
    }
  }, [searchParams, navigate])

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Logging you in...</p>
      </div>
    </div>
  )
}

export { AutoLogin }
